import { Component, forwardRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QuestionType } from 'library-explorer';

@Component({
    selector: 'app-question-free-text',
    templateUrl: './question-free-text.component.html',
    styleUrls: ['./question-free-text.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => QuestionFreeTextComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class QuestionFreeTextComponent implements ControlValueAccessor {
  @Input() public question: string;

  @Input() public questionHash: string;
  public disabled = false;

  public answer: string;

  onChange = (data: any) => {};
  onTouched = () => {};


  constructor() { }

  public answerChanged(): void {
    if (this.answer) {
      this.onChange({
        questionHash: this.questionHash,
        type: QuestionType.QUESTION_FREE_TEXT,
        answer: this.answer
      });

      return;
    }

    this.onChange(null);
  }

  public writeValue(obj: any): void {}

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}

